import "./Chip.css";

function Chip({ clicked, onClick, content }) {
  return (
    <div
      className={`chip${clicked === content ? " active" : ""}`}
      onClick={() => onClick(content)}
    >
      {content}
    </div>
  );
}

export default Chip;
